import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
// import App from './test/pivot_test'

import './global-styles/index.scss';

ReactDOM.render(<App />,document.getElementById('root'))